"use client";

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import type { ThemeProviderProps } from "@mui/material/styles";
import React, { useMemo } from "react";
import { createCustomTheme, type SsrDeviceType } from "#/themes";
type StateThemeProviderProps = Omit<ThemeProviderProps, "theme"> & {
  ssrDeviceType?: SsrDeviceType;
};
export const StateThemeProvider: React.FC<StateThemeProviderProps> = t0 => {
  const $ = _c(11);
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      ssrDeviceType: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
  }
  const ssrDeviceType = t1 === undefined ? "desktop" : t1;
  let t2;
  if ($[4] !== ssrDeviceType) {
    t2 = createCustomTheme(ssrDeviceType);
    $[4] = ssrDeviceType;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const theme = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CssBaseline />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children || $[8] !== props || $[9] !== theme) {
    t4 = <ThemeProvider theme={theme} {...props}>{t3}{children}</ThemeProvider>;
    $[7] = children;
    $[8] = props;
    $[9] = theme;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};